import { AppPaths } from "@p0security/shared/routes/constants";
import { Page } from "components/App/Page";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate, Route, useLocation, useParams } from "react-router";

import { Jit } from "./Jit";
import { IntegrationsProvider } from "./Requests/contexts/IntegrationsContext";
import { ActivePreApproval } from "./Requests/pages/ActivePreApprovalPage";
import { ActiveRequests } from "./Requests/pages/ActiveRequestsPage";
import { RequestHistory } from "./Requests/pages/RequestHistoryPage";
import { ShellPage } from "./Requests/pages/ShellPage";
import { JitPaths } from "./paths";

const JitLegacyRedirect = () => {
  const { orgSlug } = useParams();
  const { pathname, search, hash } = useLocation();
  const destination = pathname.replace(
    `/o/${orgSlug}/jit`,
    `/o/${orgSlug}/${AppPaths.AccessManagement}`
  );
  return <Navigate to={`${destination}${search}${hash}`} replace />;
};

export const JitRoutes = () => {
  const flags = useFlags();
  return (
    <>
      <Route path={AppPaths.AccessManagement} element={<Jit />}>
        <Route index element={<Navigate to="activity" replace />} />
        <Route
          path={JitPaths.Activity}
          element={
            <IntegrationsProvider>
              <Page title={"Access Management Activity"}>
                <ActiveRequests />
              </Page>
            </IntegrationsProvider>
          }
        >
          <Route path=":requestId" element={<></>} />
        </Route>
        {flags.showEvidenceStore && (
          <Route
            path={JitPaths.PreApprovals}
            element={
              <IntegrationsProvider>
                <Page title={"Pre Approvals"}>
                  <ActivePreApproval />
                </Page>
              </IntegrationsProvider>
            }
          />
        )}
        {flags.showExperimentalWebShell && (
          <Route
            path={JitPaths.Shell}
            element={
              <IntegrationsProvider>
                <Page title={"Shell"}>
                  <ShellPage />
                </Page>
              </IntegrationsProvider>
            }
          />
        )}
        <Route
          path={JitPaths.History}
          element={
            <IntegrationsProvider>
              <Page title={"Access Management History"}>
                <RequestHistory />
              </Page>
            </IntegrationsProvider>
          }
        >
          <Route path=":requestId" element={<></>} />
        </Route>
      </Route>
      <Route path="jit/*" element={<JitLegacyRedirect />} />
    </>
  );
};
